import { isListedMarket } from './access-scope.helper';

import type { MarketInfo } from '@ping/api';
import type { IMarketDataType } from '@ping/websockets';

const emptyTicker = (instrument: string): IMarketDataType => ({
  instrument,
  CoinGeckoPrice: 0,
  close: 0,
  open: 0,
  high: 0,
  low: 0,
  volume: 0,
  start: '',
  end: '',
  oldClose: 0,
});

/**
 * MiniTicker / marketdata only streams Visible markets (anonymous CanAccess).
 * FO `/api/info` already CanAccess-filters and returns Internal markets for tagged users.
 * Merge those listed markets into ticker data so Trade/Markets UIs can show them.
 */
export function mergeListedMarketsFromInfo(
  marketValues: IMarketDataType[],
  marketInfo?: Record<string, MarketInfo> | null
): IMarketDataType[] {
  if (!marketInfo) {
    return marketValues;
  }

  const existing = new Set(marketValues.map(m => m.instrument?.toLowerCase()).filter(Boolean));
  const missing: IMarketDataType[] = [];

  for (const [instrument, info] of Object.entries(marketInfo)) {
    if (!instrument || !isListedMarket(info)) {
      continue;
    }
    if (existing.has(instrument.toLowerCase())) {
      continue;
    }
    missing.push(emptyTicker(instrument));
  }

  return missing.length ? [...marketValues, ...missing] : marketValues;
}
